<template>
    <div :class="active1 ? '' : ''" style="display: flex; flex-direction: column; font-weight: 500; transition: all 0.3s;">
        <Transition name="fade">
            <div v-if="active1" class="gradient_back_pro"></div>
        </Transition>
        <Transition name="fade">
            <div v-if="active2" class="gradient_back_common"></div>
        </Transition>
        <div style="position: relative; display: flex; align-items: center;">
            <div @click="() => { $GlobalStore.closeLastModal() }" style="padding: 20px; display: flex; align-items: center;">
                <img :src="require('@/assets/img/white_x_btn.png')" style="width: 14px;" alt="">
            </div>
            <div style="flex:1;"></div>
            <div style="width:54px; display:grid;place-items: center;" @click="shareSelectPosition"><img :src="require('@/assets/img/position_share_btn.png')" style="width:18px; height:20px;"></div>
        </div>
        <div>
            <swiper ref="swiper" :options="swiperOption" role="tablist">
                <swiperSlide style="display: flex; justify-content: center; align-items: center; flex-direction: column; height: 470px;">
                    <!-- <div @click="findPositionPro" :class="active1 ? 'active' : 'unactive'" :style="{ marginRight: active1 ? '' : '-60%' }" style="transition: all 0.32s; border-radius: 24px; box-shadow: 0px 1px 10px 0px #2D140433; background-color: #210f03; padding: 25px 20px; justify-content: space-between; display: flex; flex-direction: column;">
                        <img :src="require('@/assets/img/find_position_pro.png')" alt="">
                    </div> -->
                    <div :style="{ marginRight: active1 ? '' : '-135px' }" :class="active1 ? 'active' : 'unactive'" style="transition: all 0.3s; display: flex; align-items: center; position: relative; z-index: 10;">
                        <img data-swiper-slide-index="0" style="width: 100%;" :src="require('@/assets/img/find_position_common.png')" alt="">
                        <img v-if="showBanner" @click="getSoccerShoe" :style="{ width: active1 ? '287px' : '206px', top: active1 ? '-111px' : '-80px' }" style="position: absolute; right: -10px; transition: all 0.3s;" :src="require('@/assets/img/pro_ballon.png')" alt="">
                    </div>
                </swiperSlide>
                <swiperSlide style="display: flex; justify-content: center; align-items: center;flex-direction: column;  height: 470px; position: relative;">
                    <!-- <div @click="findPosition" :style="{ marginLeft: active2 ? '' : '-62%' }" :class="active2 ? 'active' : 'unactive'" style=" transition: all 0.32s;border-radius: 24px; box-shadow: 0px 1px 10px 0px #2D140433; background-color: var(--color-main); padding: 25px 20px; padding-top: 15px; justify-content: space-between; display: flex; flex-direction: column;">
                        <img :src="require('@/assets/img/find_position_common.png')" alt="">
                    </div> -->
                    <div :class="active2 ? 'active' : 'unactive'" :style="{ marginLeft: active2 ? '' : '-135px' }" style="transition: all 0.3s; display: flex; align-items: center; position: relative;">
                        <img data-swiper-slide-index="1" style="width: 100%;" :src="require('@/assets/img/find_position_pro.png')" alt="">
                    </div>
                </swiperSlide>
            </swiper>
        </div>
        <div style="padding: 0 20px; margin-top: 30px;">
            <div @click="goPosition" :class="active1 ? 'pro_btn' : 'common_btn'" style="transition: all 0.3s;">선택</div>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { POSITION_TYPE } from '@/Constants'
import 'swiper/dist/css/swiper.min.css'
import moment from 'moment'

export default {
    name: "SelectFindPosition",
    components: { swiper, swiperSlide },
    data() {
        return {
            swiperOption: {
                slidesPerView: 1,
                spaceBetween: 6, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                curIndex: 0,
                on: {
                    slideChange: () => {
                        if (this.$refs.swiper.swiper) {
                            this.activeIndex = this.$refs.swiper.swiper.activeIndex; // 수정된 부분
                            this.updateItemWidth();
                        }
                    },
                    click: (event) => {
                        const clickedSlideIndex = event.target.getAttribute('data-swiper-slide-index');
                        this.activeIndex = clickedSlideIndex
                        if (this.active1 && this.activeIndex == 0) {
                            this.findPositionPro()
                        }
                        if (this.active2 && this.activeIndex == 1) {
                            this.findPosition()
                        }
                        this.$refs.swiper.swiper.slideTo(clickedSlideIndex);
                    }
                },
                initialSlide: 0,
            },
            active1: true,
            active2: false,
            activeIndex: 0,
            saveIndex: -1,
            showBanner: true,
            POSITION_TYPE: POSITION_TYPE
        }
    },
    methods: {
        shareSelectPosition() {
            const device = this.$cookies.get('device');

            let domain = '';
            if (process.env.NODE_ENV === 'development') {
                domain = 'http://192.168.0.203:8080';
            } else {
                if (process.env.VUE_APP_IS_TEST_SERVER !== undefined) {
                    domain = 'https://obyungear-user-test.ubiplus.co.kr';
                } else {
                    domain = 'https://app.soccerhow.com';
                }
            }

            let url = `${domain}/position`;
            console.log(url);
            const message = '포지션 찾기';

            if (device === 'android') {
                const text = (message === "" ? "" : message + "\n") + url;
                window.Android.shareUrl(text);
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'shareUrl', text: message, url: url });
            } else {
                navigator.share({
                    title: message,
                    url: url
                }).then(() => {
                    console.log('Thanks for sharing!');
                }).catch(() => {
                    console.log('share error');
                });
            }
        },
        updateItemWidth() {
            if (this.activeIndex === 0) {
                this.active1 = true
                this.active2 = false
            } else {
                this.active2 = true
                this.active1 = false
            }
        },
        getSoccerShoe() {
            this.$Util.showBrowser('https://www.instagram.com/p/C1lqlGGrJir/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==')
        },
        findPosition() {
            this.$Util.sendEventClick('포지션찾기_LITE', true)
            this.$GlobalStore.addModal('FindPositionProMain', { type: POSITION_TYPE.LITE });
        },
        findPositionPro() {
            this.$Util.sendEventClick('포지션찾기_PRO', true)
            this.$GlobalStore.addModal('FindPositionProMain', { type: POSITION_TYPE.PRO });
        },
        goPosition() {
            if (this.active1) {
                this.findPositionPro()
            } else {
                this.findPosition()
            }
        }
    },
    mounted() {
        this.activeIndex = 0;
        this.updateItemWidth()
    },
    created() {
        if (this.$Util.isShowDefaultSettings()) {
            return
        }
        const today = moment()
        if (today.isAfter('2024-02-02', 'day')) {
            this.showBanner = false
        }
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}

.start_position {
    width: 117px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 22.5px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    box-shadow: 0px 1px 5px 0px #10101433;
    background: #fff;
    margin: 0 auto;
}

.swiper-slide.swiper-slide-active .hi {
    width: 100px;
}

.active {
    width: calc(100% - 40px);
}

.unactive {
    width: calc(100% - 100px)
}

.pro_btn {
    background: #fff;
    height: 46px;
    border-radius: 22.5px;
    text-align: center;
    line-height: 46px;
    font-size: 14px;
    font-weight: 500;
}

.common_btn {
    background: var(--color-main);
    color: #fff;
    height: 46px;
    border-radius: 22.5px;
    text-align: center;
    line-height: 46px;
    font-size: 14px;
    font-weight: 500;
}

.gradient_back_pro {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    background: linear-gradient(180deg, #1370AF 0%, #210F03 31.66%);
}

.gradient_back_common {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    background: linear-gradient(180deg, #FFDFCA 0%, #FFFFFF 29.91%);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}
</style>